document.addEventListener('DOMContentLoaded', () => {
	// 実際のヘッダーの高さを計測して --header-height に反映（rem指定とのズレを防ぐ）
	const mainHeader = document.querySelector('.main-header');
	if (mainHeader) {
		const syncHeaderHeight = () => {
			document.documentElement.style.setProperty('--header-height', `${mainHeader.offsetHeight}px`);
		};
		syncHeaderHeight();
		window.addEventListener('resize', syncHeaderHeight);
	}

	const hamburger = document.getElementById('js-hamburger');
	const nav = document.getElementById('js-header-nav');
	const overlay = document.getElementById('js-nav-overlay');
	const closeBtn = document.getElementById('js-nav-close');

	if (!hamburger || !nav || !overlay) return;

	const openNav = () => {
		hamburger.classList.add('is-active');
		nav.classList.add('is-active');
		overlay.classList.add('is-active');
	};

	const closeNav = () => {
		hamburger.classList.remove('is-active');
		nav.classList.remove('is-active');
		overlay.classList.remove('is-active');
		nav.querySelectorAll('li.is-open').forEach((li) => li.classList.remove('is-open'));
	};

	hamburger.addEventListener('click', () => {
		nav.classList.contains('is-active') ? closeNav() : openNav();
	});

	overlay.addEventListener('click', closeNav);
	closeBtn?.addEventListener('click', closeNav);

	nav.querySelectorAll('.nav-toggle').forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const li = toggle.closest('li');
			const isOpen = li.classList.contains('is-open');

			nav.querySelectorAll('li.is-open').forEach((openLi) => {
				if (openLi !== li) openLi.classList.remove('is-open');
			});

			li.classList.toggle('is-open', !isOpen);
		});
	});

	document.addEventListener('click', (e) => {
		if (!e.target.closest('.header-nav li.has-mega')) {
			nav.querySelectorAll('li.is-open').forEach((li) => li.classList.remove('is-open'));
		}
	});

	// スクロール時にヘッダーを自動的に隠す（下スクロールで隠す、上スクロールで表示）
	const header = document.querySelector('.main-header');
	if (header) {
		let lastScrollY = window.scrollY;
		const hideThreshold = header.offsetHeight;

		window.addEventListener('scroll', () => {
			if (nav.classList.contains('is-active')) return;

			const currentScrollY = window.scrollY;
			if (currentScrollY > lastScrollY && currentScrollY > hideThreshold) {
				header.classList.add('is-hidden');
			} else {
				header.classList.remove('is-hidden');
			}
			lastScrollY = currentScrollY;
		}, { passive: true });
	}
});
